module.exports = __webpack_public_path__ + "gps/gps-fc25cfb58b7e4a3b0eeeb8c4ae300000.svg";